import api from "./api";

const WorkItemService = {

    // getAll: async (page = 1, limit = 20) => {
    //    const res = await api.get("/workitems/getAll");
    //     return res.data;
    // },

    getAll: async (pageNumber = 1, noOfRows = 20, search = "",projectCategoryId = "") => {
        const res = await api.get(
            `/workitems/getAll?pageNumber=${pageNumber}&noOfRows=${noOfRows}&search=${search}&projectCategoryId=${projectCategoryId}`
        );
        return res.data;
    },

    getActive: async () => {
        const res = await api.get("/workitems/getActive");
        return res.data;
    },

    save: async (data) => {
        const res = await api.post("/workitems/save", data);
        return res.data;
    },

    getById: async (id) => {
        const res = await api.get(`/workitems/getById/${id}`);
        return res.data;
    },

    update: async (id, data) => {
        const res = await api.put(`/workitems/update/${id}`, data);
        return res.data;
    },

    updateStatus: async (id, status) => {
        const res = await api.put(`/workitems/updateStatus/${id}`, { status });
        return res.data;
    },

    delete: async (id) => {
        const res = await api.delete(`/workitems/${id}`);
        return res.data;
    }

};

export default WorkItemService;
